var map = {
	"./decidim/gamification/badges/decidim_gamification_badges_attended_meetings.svg": "../decidim-meetings/app/packs/images/decidim/gamification/badges/decidim_gamification_badges_attended_meetings.svg",
	"./decidim/meetings/decidim_meetings.svg": "../decidim-meetings/app/packs/images/decidim/meetings/decidim_meetings.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../decidim-meetings/app/packs/images sync recursive ^\\.\\/.*$";